var render, staticRenderFns
import script from "./distributionList.vue?vue&type=script&lang=js"
export * from "./distributionList.vue?vue&type=script&lang=js"
import style0 from "./distributionList.vue?vue&type=style&index=0&id=0db0f2c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db0f2c2",
  null
  
)

export default component.exports